/**
 * Internal dependencies
 */
import SmoothScroll from "./smooth-scroll";
import CategoryMenu from "../components/category-menu";

export default class {
	constructor() {
		const header = document.querySelector(".site-header");
		const adminbar = document.querySelector("#wpadminbar");

		this.offset = 0;
		this.categoryMenu = new CategoryMenu({
			onHashChange: this.handleHashChange.bind(this),
		});

		this.smoothScroll = new SmoothScroll({
			offset: target => {
				let offset = this.offset + (header ? header.clientHeight : 0);

				if (
					["P", "H1", "H2", "H3", "H4", "H5", "H6"].includes(target.nodeName)
				) {
					offset += 24;
				}

				if (
					adminbar &&
					"absolute" === window.getComputedStyle(adminbar).position
				) {
					offset -= adminbar.clientHeight;
				}

				return offset;
			},
			onScrollStart: () => this.categoryMenu.disable(),
		});

		this.calculateMenuOffset();

		window.addEventListener("resize", this.calculateMenuOffset.bind(this));
	}

	calculateMenuOffset() {
		this.offset = 0;

		if (this.categoryMenu.menu) {
			const menuStyle = window.getComputedStyle(this.categoryMenu.menu);

			if (parseInt(menuStyle.left) === parseInt(menuStyle.right)) {
				this.offset = this.categoryMenu.menu.offsetHeight;
			}
		}
	}

	handleHashChange(hash) {
		const enableSmoothScroll = () => {
			this.smoothScroll.enable();
			window.removeEventListener("hashchange", enableSmoothScroll);
		};

		window.addEventListener("hashchange", enableSmoothScroll);

		this.smoothScroll.disable();

		window.location.hash = hash;
	}
}
